import React from 'react';
import { Outlet } from 'react-router-dom';

function ParticipantsScene() {
  return <Outlet />;
}

export default ParticipantsScene;
